import { React } from 'react';
import styled from 'styled-components';

function InputView(props) {
  const { isClicked, column, content } = props;

  return (
    <TopLevelWrpper>
      <Column>{column}</Column>
      <InputBox isClicked={isClicked}>
        <Content>{content}</Content>
      </InputBox>
    </TopLevelWrpper>
  )
}

export default InputView;

const TopLevelWrpper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
`;

const InputBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin-top: 8px;

  width: 363px;
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.isClicked ? props.theme.primaryAlpha50 : props.theme.subBackground};

`;

const Column = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Content = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 8px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;